// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=js"
// @generated from file agentplatform/httpv2/memory.proto (package infinigence.infini.agentplatform.httpv2, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { ListRequestSchema } from "./common_pb.js";
import { file_agentplatform_httpv2_common } from "./common_pb.js";
import type { Memory, MemoryClass } from "../v1/memory_pb.js";
import { file_agentplatform_v1_memory } from "../v1/memory_pb.js";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb.js";
import { file_google_api_annotations } from "../../google/api/annotations_pb.js";
import { file_google_protobuf_struct } from "@bufbuild/protobuf/wkt";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file agentplatform/httpv2/memory.proto.
 */
export const file_agentplatform_httpv2_memory: GenFile = /*@__PURE__*/
  fileDesc("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", [file_agentplatform_httpv2_common, file_agentplatform_v1_memory, file_buf_validate_validate, file_google_api_annotations, file_google_protobuf_struct]);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListMemoryClassesResponse
 */
export type ListMemoryClassesResponse = Message<"infinigence.infini.agentplatform.httpv2.ListMemoryClassesResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.ListMemoryClassesData data = 4;
   */
  data?: ListMemoryClassesData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListMemoryClassesResponse.
 * Use `create(ListMemoryClassesResponseSchema)` to create a new message.
 */
export const ListMemoryClassesResponseSchema: GenMessage<ListMemoryClassesResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 0);

/**
 * List 字段量大，按 spec §3.3 例外条款允许直接复用资源 message。
 *
 * @generated from message infinigence.infini.agentplatform.httpv2.ListMemoryClassesData
 */
export type ListMemoryClassesData = Message<"infinigence.infini.agentplatform.httpv2.ListMemoryClassesData"> & {
  /**
   * @gotags: json:"items"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v1.MemoryClass items = 1;
   */
  items: MemoryClass[];

  /**
   * @gotags: json:"total"
   *
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListMemoryClassesData.
 * Use `create(ListMemoryClassesDataSchema)` to create a new message.
 */
export const ListMemoryClassesDataSchema: GenMessage<ListMemoryClassesData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 1);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CreateMemoryClassRequest
 */
export type CreateMemoryClassRequest = Message<"infinigence.infini.agentplatform.httpv2.CreateMemoryClassRequest"> & {
  /**
   * 记忆类定义（归属 tenant_id / user_id 由服务端从鉴权信息回填）
   * @gotags: json:"memory_class"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.MemoryClass memory_class = 1 [json_name = "memory_class"];
   */
  memoryClass?: MemoryClass | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CreateMemoryClassRequest.
 * Use `create(CreateMemoryClassRequestSchema)` to create a new message.
 */
export const CreateMemoryClassRequestSchema: GenMessage<CreateMemoryClassRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 2);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CreateMemoryClassResponse
 */
export type CreateMemoryClassResponse = Message<"infinigence.infini.agentplatform.httpv2.CreateMemoryClassResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.MemoryClass data = 4;
   */
  data?: MemoryClass | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CreateMemoryClassResponse.
 * Use `create(CreateMemoryClassResponseSchema)` to create a new message.
 */
export const CreateMemoryClassResponseSchema: GenMessage<CreateMemoryClassResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 3);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetMemoryClassRequest
 */
export type GetMemoryClassRequest = Message<"infinigence.infini.agentplatform.httpv2.GetMemoryClassRequest"> & {
  /**
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetMemoryClassRequest.
 * Use `create(GetMemoryClassRequestSchema)` to create a new message.
 */
export const GetMemoryClassRequestSchema: GenMessage<GetMemoryClassRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 4);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetMemoryClassResponse
 */
export type GetMemoryClassResponse = Message<"infinigence.infini.agentplatform.httpv2.GetMemoryClassResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.MemoryClass data = 4;
   */
  data?: MemoryClass | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetMemoryClassResponse.
 * Use `create(GetMemoryClassResponseSchema)` to create a new message.
 */
export const GetMemoryClassResponseSchema: GenMessage<GetMemoryClassResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 5);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UpdateMemoryClassRequest
 */
export type UpdateMemoryClassRequest = Message<"infinigence.infini.agentplatform.httpv2.UpdateMemoryClassRequest"> & {
  /**
   * 待更新记忆类 ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 记忆类定义（id / 归属由服务端回填）
   * @gotags: json:"memory_class"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.MemoryClass memory_class = 2 [json_name = "memory_class"];
   */
  memoryClass?: MemoryClass | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UpdateMemoryClassRequest.
 * Use `create(UpdateMemoryClassRequestSchema)` to create a new message.
 */
export const UpdateMemoryClassRequestSchema: GenMessage<UpdateMemoryClassRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 6);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UpdateMemoryClassResponse
 */
export type UpdateMemoryClassResponse = Message<"infinigence.infini.agentplatform.httpv2.UpdateMemoryClassResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.MemoryClass data = 4;
   */
  data?: MemoryClass | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UpdateMemoryClassResponse.
 * Use `create(UpdateMemoryClassResponseSchema)` to create a new message.
 */
export const UpdateMemoryClassResponseSchema: GenMessage<UpdateMemoryClassResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 7);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteMemoryClassRequest
 */
export type DeleteMemoryClassRequest = Message<"infinigence.infini.agentplatform.httpv2.DeleteMemoryClassRequest"> & {
  /**
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteMemoryClassRequest.
 * Use `create(DeleteMemoryClassRequestSchema)` to create a new message.
 */
export const DeleteMemoryClassRequestSchema: GenMessage<DeleteMemoryClassRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 8);

/**
 * 删除幂等：成功 / 不存在都返回 HTTP 200，envelope code "200"，不带 data
 *
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteMemoryClassResponse
 */
export type DeleteMemoryClassResponse = Message<"infinigence.infini.agentplatform.httpv2.DeleteMemoryClassResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteMemoryClassResponse.
 * Use `create(DeleteMemoryClassResponseSchema)` to create a new message.
 */
export const DeleteMemoryClassResponseSchema: GenMessage<DeleteMemoryClassResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 9);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListMemoriesResponse
 */
export type ListMemoriesResponse = Message<"infinigence.infini.agentplatform.httpv2.ListMemoriesResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.ListMemoriesData data = 4;
   */
  data?: ListMemoriesData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListMemoriesResponse.
 * Use `create(ListMemoriesResponseSchema)` to create a new message.
 */
export const ListMemoriesResponseSchema: GenMessage<ListMemoriesResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 10);

/**
 * List 字段量大，按 spec §3.3 例外条款允许直接复用资源 message。
 *
 * @generated from message infinigence.infini.agentplatform.httpv2.ListMemoriesData
 */
export type ListMemoriesData = Message<"infinigence.infini.agentplatform.httpv2.ListMemoriesData"> & {
  /**
   * @gotags: json:"items"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v1.Memory items = 1;
   */
  items: Memory[];

  /**
   * @gotags: json:"total"
   *
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListMemoriesData.
 * Use `create(ListMemoriesDataSchema)` to create a new message.
 */
export const ListMemoriesDataSchema: GenMessage<ListMemoriesData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 11);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CreateMemoryRequest
 */
export type CreateMemoryRequest = Message<"infinigence.infini.agentplatform.httpv2.CreateMemoryRequest"> & {
  /**
   * 记忆实例定义（归属 tenant_id / user_id 由服务端从鉴权信息回填）
   * @gotags: json:"memory"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.Memory memory = 1;
   */
  memory?: Memory | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CreateMemoryRequest.
 * Use `create(CreateMemoryRequestSchema)` to create a new message.
 */
export const CreateMemoryRequestSchema: GenMessage<CreateMemoryRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 12);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CreateMemoryResponse
 */
export type CreateMemoryResponse = Message<"infinigence.infini.agentplatform.httpv2.CreateMemoryResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.Memory data = 4;
   */
  data?: Memory | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CreateMemoryResponse.
 * Use `create(CreateMemoryResponseSchema)` to create a new message.
 */
export const CreateMemoryResponseSchema: GenMessage<CreateMemoryResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 13);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetMemoryRequest
 */
export type GetMemoryRequest = Message<"infinigence.infini.agentplatform.httpv2.GetMemoryRequest"> & {
  /**
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetMemoryRequest.
 * Use `create(GetMemoryRequestSchema)` to create a new message.
 */
export const GetMemoryRequestSchema: GenMessage<GetMemoryRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 14);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetMemoryResponse
 */
export type GetMemoryResponse = Message<"infinigence.infini.agentplatform.httpv2.GetMemoryResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.Memory data = 4;
   */
  data?: Memory | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetMemoryResponse.
 * Use `create(GetMemoryResponseSchema)` to create a new message.
 */
export const GetMemoryResponseSchema: GenMessage<GetMemoryResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 15);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UpdateMemoryRequest
 */
export type UpdateMemoryRequest = Message<"infinigence.infini.agentplatform.httpv2.UpdateMemoryRequest"> & {
  /**
   * 待更新记忆实例 ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 记忆实例定义（id / 归属由服务端回填）
   * @gotags: json:"memory"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.Memory memory = 2;
   */
  memory?: Memory | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UpdateMemoryRequest.
 * Use `create(UpdateMemoryRequestSchema)` to create a new message.
 */
export const UpdateMemoryRequestSchema: GenMessage<UpdateMemoryRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 16);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UpdateMemoryResponse
 */
export type UpdateMemoryResponse = Message<"infinigence.infini.agentplatform.httpv2.UpdateMemoryResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.Memory data = 4;
   */
  data?: Memory | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UpdateMemoryResponse.
 * Use `create(UpdateMemoryResponseSchema)` to create a new message.
 */
export const UpdateMemoryResponseSchema: GenMessage<UpdateMemoryResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 17);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteMemoryRequest
 */
export type DeleteMemoryRequest = Message<"infinigence.infini.agentplatform.httpv2.DeleteMemoryRequest"> & {
  /**
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteMemoryRequest.
 * Use `create(DeleteMemoryRequestSchema)` to create a new message.
 */
export const DeleteMemoryRequestSchema: GenMessage<DeleteMemoryRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 18);

/**
 * 删除幂等：成功 / 不存在都返回 HTTP 200，envelope code "200"，不带 data
 *
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteMemoryResponse
 */
export type DeleteMemoryResponse = Message<"infinigence.infini.agentplatform.httpv2.DeleteMemoryResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteMemoryResponse.
 * Use `create(DeleteMemoryResponseSchema)` to create a new message.
 */
export const DeleteMemoryResponseSchema: GenMessage<DeleteMemoryResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 19);

/**
 * CortexMessage 是创建记忆条目时携带的对话消息。
 *
 * @generated from message infinigence.infini.agentplatform.httpv2.CortexMessage
 */
export type CortexMessage = Message<"infinigence.infini.agentplatform.httpv2.CortexMessage"> & {
  /**
   * 角色（user / assistant / system 等）
   * @gotags: json:"role"
   *
   * @generated from field: string role = 1;
   */
  role: string;

  /**
   * 消息内容
   * @gotags: json:"content"
   *
   * @generated from field: string content = 2;
   */
  content: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CortexMessage.
 * Use `create(CortexMessageSchema)` to create a new message.
 */
export const CortexMessageSchema: GenMessage<CortexMessage> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 20);

/**
 * CortexMemoryItem 对应 cortex 服务返回的单条记忆。
 *
 * @generated from message infinigence.infini.agentplatform.httpv2.CortexMemoryItem
 */
export type CortexMemoryItem = Message<"infinigence.infini.agentplatform.httpv2.CortexMemoryItem"> & {
  /**
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @gotags: json:"memory"
   *
   * @generated from field: string memory = 2;
   */
  memory: string;

  /**
   * @gotags: json:"hash,omitempty"
   *
   * @generated from field: string hash = 3;
   */
  hash: string;

  /**
   * @gotags: json:"metadata,omitempty"
   *
   * @generated from field: google.protobuf.Struct metadata = 4;
   */
  metadata?: JsonObject | undefined;

  /**
   * @gotags: json:"user_id,omitempty"
   *
   * @generated from field: string user_id = 5 [json_name = "user_id"];
   */
  userId: string;

  /**
   * 相关性得分（检索结果才有）
   * @gotags: json:"score,omitempty"
   *
   * @generated from field: optional double score = 6;
   */
  score?: number | undefined;

  /**
   * @gotags: json:"created_at,omitempty"
   *
   * @generated from field: string created_at = 7 [json_name = "created_at"];
   */
  createdAt: string;

  /**
   * @gotags: json:"updated_at,omitempty"
   *
   * @generated from field: string updated_at = 8 [json_name = "updated_at"];
   */
  updatedAt: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CortexMemoryItem.
 * Use `create(CortexMemoryItemSchema)` to create a new message.
 */
export const CortexMemoryItemSchema: GenMessage<CortexMemoryItem> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 21);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CortexItemsData
 */
export type CortexItemsData = Message<"infinigence.infini.agentplatform.httpv2.CortexItemsData"> & {
  /**
   * @gotags: json:"items"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.httpv2.CortexMemoryItem items = 1;
   */
  items: CortexMemoryItem[];

  /**
   * @gotags: json:"total"
   *
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CortexItemsData.
 * Use `create(CortexItemsDataSchema)` to create a new message.
 */
export const CortexItemsDataSchema: GenMessage<CortexItemsData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 22);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListCortexItemsRequest
 */
export type ListCortexItemsRequest = Message<"infinigence.infini.agentplatform.httpv2.ListCortexItemsRequest"> & {
  /**
   * 目标 store（记忆实例的 store_id）
   * @gotags: json:"store_id"
   *
   * @generated from field: string store_id = 1 [json_name = "store_id"];
   */
  storeId: string;

  /**
   * 用户 ID（可选过滤）
   * @gotags: json:"user_id,omitempty"
   *
   * @generated from field: string user_id = 2 [json_name = "user_id"];
   */
  userId: string;

  /**
   * 返回条数上限（0 / 缺省 = 100）
   * @gotags: json:"limit,omitempty"
   *
   * @generated from field: int32 limit = 3;
   */
  limit: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListCortexItemsRequest.
 * Use `create(ListCortexItemsRequestSchema)` to create a new message.
 */
export const ListCortexItemsRequestSchema: GenMessage<ListCortexItemsRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 23);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListCortexItemsResponse
 */
export type ListCortexItemsResponse = Message<"infinigence.infini.agentplatform.httpv2.ListCortexItemsResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.CortexItemsData data = 4;
   */
  data?: CortexItemsData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListCortexItemsResponse.
 * Use `create(ListCortexItemsResponseSchema)` to create a new message.
 */
export const ListCortexItemsResponseSchema: GenMessage<ListCortexItemsResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 24);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetCortexItemRequest
 */
export type GetCortexItemRequest = Message<"infinigence.infini.agentplatform.httpv2.GetCortexItemRequest"> & {
  /**
   * 记忆条目 ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 目标 store
   * @gotags: json:"store_id"
   *
   * @generated from field: string store_id = 2 [json_name = "store_id"];
   */
  storeId: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetCortexItemRequest.
 * Use `create(GetCortexItemRequestSchema)` to create a new message.
 */
export const GetCortexItemRequestSchema: GenMessage<GetCortexItemRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 25);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetCortexItemResponse
 */
export type GetCortexItemResponse = Message<"infinigence.infini.agentplatform.httpv2.GetCortexItemResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.CortexMemoryItem data = 4;
   */
  data?: CortexMemoryItem | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetCortexItemResponse.
 * Use `create(GetCortexItemResponseSchema)` to create a new message.
 */
export const GetCortexItemResponseSchema: GenMessage<GetCortexItemResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 26);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CreateCortexItemRequest
 */
export type CreateCortexItemRequest = Message<"infinigence.infini.agentplatform.httpv2.CreateCortexItemRequest"> & {
  /**
   * 对话消息（与 memory 二选一）
   * @gotags: json:"messages,omitempty"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.httpv2.CortexMessage messages = 1;
   */
  messages: CortexMessage[];

  /**
   * 记忆正文（与 messages 二选一）
   * @gotags: json:"memory,omitempty"
   *
   * @generated from field: string memory = 2;
   */
  memory: string;

  /**
   * 用户 ID
   * @gotags: json:"user_id"
   *
   * @generated from field: string user_id = 3 [json_name = "user_id"];
   */
  userId: string;

  /**
   * 目标 store
   * @gotags: json:"store_id"
   *
   * @generated from field: string store_id = 4 [json_name = "store_id"];
   */
  storeId: string;

  /**
   * 附加元数据
   * @gotags: json:"metadata,omitempty"
   *
   * @generated from field: google.protobuf.Struct metadata = 5;
   */
  metadata?: JsonObject | undefined;

  /**
   * 抽取提示词
   * @gotags: json:"prompt,omitempty"
   *
   * @generated from field: string prompt = 6;
   */
  prompt: string;

  /**
   * 是否推断抽取（缺省 = true）
   * @gotags: json:"infer,omitempty"
   *
   * @generated from field: optional bool infer = 7;
   */
  infer?: boolean | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CreateCortexItemRequest.
 * Use `create(CreateCortexItemRequestSchema)` to create a new message.
 */
export const CreateCortexItemRequestSchema: GenMessage<CreateCortexItemRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 27);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CreateCortexItemResponse
 */
export type CreateCortexItemResponse = Message<"infinigence.infini.agentplatform.httpv2.CreateCortexItemResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * cortex 返回的原始结果（结构随 provider 变化）
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: google.protobuf.Struct data = 4;
   */
  data?: JsonObject | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CreateCortexItemResponse.
 * Use `create(CreateCortexItemResponseSchema)` to create a new message.
 */
export const CreateCortexItemResponseSchema: GenMessage<CreateCortexItemResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 28);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UpdateCortexItemRequest
 */
export type UpdateCortexItemRequest = Message<"infinigence.infini.agentplatform.httpv2.UpdateCortexItemRequest"> & {
  /**
   * 记忆条目 ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 目标 store
   * @gotags: json:"store_id"
   *
   * @generated from field: string store_id = 2 [json_name = "store_id"];
   */
  storeId: string;

  /**
   * 新的记忆正文
   * @gotags: json:"data"
   *
   * @generated from field: string data = 3;
   */
  data: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UpdateCortexItemRequest.
 * Use `create(UpdateCortexItemRequestSchema)` to create a new message.
 */
export const UpdateCortexItemRequestSchema: GenMessage<UpdateCortexItemRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 29);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UpdateCortexItemResponse
 */
export type UpdateCortexItemResponse = Message<"infinigence.infini.agentplatform.httpv2.UpdateCortexItemResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.CortexMemoryItem data = 4;
   */
  data?: CortexMemoryItem | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UpdateCortexItemResponse.
 * Use `create(UpdateCortexItemResponseSchema)` to create a new message.
 */
export const UpdateCortexItemResponseSchema: GenMessage<UpdateCortexItemResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 30);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteCortexItemRequest
 */
export type DeleteCortexItemRequest = Message<"infinigence.infini.agentplatform.httpv2.DeleteCortexItemRequest"> & {
  /**
   * 记忆条目 ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 目标 store
   * @gotags: json:"store_id"
   *
   * @generated from field: string store_id = 2 [json_name = "store_id"];
   */
  storeId: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteCortexItemRequest.
 * Use `create(DeleteCortexItemRequestSchema)` to create a new message.
 */
export const DeleteCortexItemRequestSchema: GenMessage<DeleteCortexItemRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 31);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteCortexItemResponse
 */
export type DeleteCortexItemResponse = Message<"infinigence.infini.agentplatform.httpv2.DeleteCortexItemResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteCortexItemResponse.
 * Use `create(DeleteCortexItemResponseSchema)` to create a new message.
 */
export const DeleteCortexItemResponseSchema: GenMessage<DeleteCortexItemResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 32);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteAllCortexItemsRequest
 */
export type DeleteAllCortexItemsRequest = Message<"infinigence.infini.agentplatform.httpv2.DeleteAllCortexItemsRequest"> & {
  /**
   * 目标 store
   * @gotags: json:"store_id"
   *
   * @generated from field: string store_id = 1 [json_name = "store_id"];
   */
  storeId: string;

  /**
   * 用户 ID
   * @gotags: json:"user_id"
   *
   * @generated from field: string user_id = 2 [json_name = "user_id"];
   */
  userId: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteAllCortexItemsRequest.
 * Use `create(DeleteAllCortexItemsRequestSchema)` to create a new message.
 */
export const DeleteAllCortexItemsRequestSchema: GenMessage<DeleteAllCortexItemsRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 33);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteAllCortexItemsResponse
 */
export type DeleteAllCortexItemsResponse = Message<"infinigence.infini.agentplatform.httpv2.DeleteAllCortexItemsResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteAllCortexItemsResponse.
 * Use `create(DeleteAllCortexItemsResponseSchema)` to create a new message.
 */
export const DeleteAllCortexItemsResponseSchema: GenMessage<DeleteAllCortexItemsResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 34);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.SearchCortexItemsRequest
 */
export type SearchCortexItemsRequest = Message<"infinigence.infini.agentplatform.httpv2.SearchCortexItemsRequest"> & {
  /**
   * 检索查询串
   * @gotags: json:"query"
   *
   * @generated from field: string query = 1;
   */
  query: string;

  /**
   * 目标 store
   * @gotags: json:"store_id"
   *
   * @generated from field: string store_id = 2 [json_name = "store_id"];
   */
  storeId: string;

  /**
   * 用户 ID（可选过滤）
   * @gotags: json:"user_id,omitempty"
   *
   * @generated from field: string user_id = 3 [json_name = "user_id"];
   */
  userId: string;

  /**
   * 额外过滤条件
   * @gotags: json:"filters,omitempty"
   *
   * @generated from field: google.protobuf.Struct filters = 4;
   */
  filters?: JsonObject | undefined;

  /**
   * 返回条数上限（0 = 由 cortex 决定）
   * @gotags: json:"limit,omitempty"
   *
   * @generated from field: int32 limit = 5;
   */
  limit: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.SearchCortexItemsRequest.
 * Use `create(SearchCortexItemsRequestSchema)` to create a new message.
 */
export const SearchCortexItemsRequestSchema: GenMessage<SearchCortexItemsRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 35);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.SearchCortexItemsResponse
 */
export type SearchCortexItemsResponse = Message<"infinigence.infini.agentplatform.httpv2.SearchCortexItemsResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.CortexItemsData data = 4;
   */
  data?: CortexItemsData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.SearchCortexItemsResponse.
 * Use `create(SearchCortexItemsResponseSchema)` to create a new message.
 */
export const SearchCortexItemsResponseSchema: GenMessage<SearchCortexItemsResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 36);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.InfiniMemoryItem
 */
export type InfiniMemoryItem = Message<"infinigence.infini.agentplatform.httpv2.InfiniMemoryItem"> & {
  /**
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @gotags: json:"kind"
   *
   * @generated from field: string kind = 2;
   */
  kind: string;

  /**
   * @gotags: json:"title"
   *
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @gotags: json:"summary"
   *
   * @generated from field: string summary = 4;
   */
  summary: string;

  /**
   * @gotags: json:"directory_id"
   *
   * @generated from field: string directory_id = 5 [json_name = "directory_id"];
   */
  directoryId: string;

  /**
   * @gotags: json:"preview"
   *
   * @generated from field: string preview = 6;
   */
  preview: string;

  /**
   * @gotags: json:"line_count"
   *
   * @generated from field: int32 line_count = 7 [json_name = "line_count"];
   */
  lineCount: number;

  /**
   * @gotags: json:"tokens"
   *
   * @generated from field: int32 tokens = 8;
   */
  tokens: number;

  /**
   * Cortex RFC3339 timestamp.
   * @gotags: json:"created_at"
   *
   * @generated from field: string created_at = 9 [json_name = "created_at"];
   */
  createdAt: string;

  /**
   * Cortex RFC3339 timestamp.
   * @gotags: json:"updated_at"
   *
   * @generated from field: string updated_at = 10 [json_name = "updated_at"];
   */
  updatedAt: string;

  /**
   * @gotags: json:"deletable"
   *
   * @generated from field: bool deletable = 11;
   */
  deletable: boolean;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.InfiniMemoryItem.
 * Use `create(InfiniMemoryItemSchema)` to create a new message.
 */
export const InfiniMemoryItemSchema: GenMessage<InfiniMemoryItem> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 37);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.InfiniMemoryDetail
 */
export type InfiniMemoryDetail = Message<"infinigence.infini.agentplatform.httpv2.InfiniMemoryDetail"> & {
  /**
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @gotags: json:"kind"
   *
   * @generated from field: string kind = 2;
   */
  kind: string;

  /**
   * @gotags: json:"title"
   *
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @gotags: json:"summary"
   *
   * @generated from field: string summary = 4;
   */
  summary: string;

  /**
   * @gotags: json:"directory_id"
   *
   * @generated from field: string directory_id = 5 [json_name = "directory_id"];
   */
  directoryId: string;

  /**
   * @gotags: json:"preview"
   *
   * @generated from field: string preview = 6;
   */
  preview: string;

  /**
   * @gotags: json:"line_count"
   *
   * @generated from field: int32 line_count = 7 [json_name = "line_count"];
   */
  lineCount: number;

  /**
   * @gotags: json:"tokens"
   *
   * @generated from field: int32 tokens = 8;
   */
  tokens: number;

  /**
   * @gotags: json:"created_at"
   *
   * @generated from field: string created_at = 9 [json_name = "created_at"];
   */
  createdAt: string;

  /**
   * @gotags: json:"updated_at"
   *
   * @generated from field: string updated_at = 10 [json_name = "updated_at"];
   */
  updatedAt: string;

  /**
   * @gotags: json:"deletable"
   *
   * @generated from field: bool deletable = 11;
   */
  deletable: boolean;

  /**
   * @gotags: json:"path"
   *
   * @generated from field: string path = 12;
   */
  path: string;

  /**
   * @gotags: json:"content"
   *
   * @generated from field: string content = 13;
   */
  content: string;

  /**
   * @gotags: json:"revision"
   *
   * @generated from field: string revision = 14;
   */
  revision: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.InfiniMemoryDetail.
 * Use `create(InfiniMemoryDetailSchema)` to create a new message.
 */
export const InfiniMemoryDetailSchema: GenMessage<InfiniMemoryDetail> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 38);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.InfiniMemoryStats
 */
export type InfiniMemoryStats = Message<"infinigence.infini.agentplatform.httpv2.InfiniMemoryStats"> & {
  /**
   * @gotags: json:"current"
   *
   * @generated from field: int32 current = 1;
   */
  current: number;

  /**
   * @gotags: json:"memory"
   *
   * @generated from field: int32 memory = 2;
   */
  memory: number;

  /**
   * @gotags: json:"total"
   *
   * @generated from field: int32 total = 3;
   */
  total: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.InfiniMemoryStats.
 * Use `create(InfiniMemoryStatsSchema)` to create a new message.
 */
export const InfiniMemoryStatsSchema: GenMessage<InfiniMemoryStats> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 39);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetInfiniMemoryScopeRequest
 */
export type GetInfiniMemoryScopeRequest = Message<"infinigence.infini.agentplatform.httpv2.GetInfiniMemoryScopeRequest"> & {
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetInfiniMemoryScopeRequest.
 * Use `create(GetInfiniMemoryScopeRequestSchema)` to create a new message.
 */
export const GetInfiniMemoryScopeRequestSchema: GenMessage<GetInfiniMemoryScopeRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 40);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetInfiniMemoryScopeResponse
 */
export type GetInfiniMemoryScopeResponse = Message<"infinigence.infini.agentplatform.httpv2.GetInfiniMemoryScopeResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.GetInfiniMemoryScopeData data = 4;
   */
  data?: GetInfiniMemoryScopeData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetInfiniMemoryScopeResponse.
 * Use `create(GetInfiniMemoryScopeResponseSchema)` to create a new message.
 */
export const GetInfiniMemoryScopeResponseSchema: GenMessage<GetInfiniMemoryScopeResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 41);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetInfiniMemoryScopeData
 */
export type GetInfiniMemoryScopeData = Message<"infinigence.infini.agentplatform.httpv2.GetInfiniMemoryScopeData"> & {
  /**
   * @gotags: json:"available"
   *
   * @generated from field: bool available = 1;
   */
  available: boolean;

  /**
   * @gotags: json:"unavailable_reason,omitempty"
   *
   * @generated from field: string unavailable_reason = 2 [json_name = "unavailable_reason"];
   */
  unavailableReason: string;

  /**
   * @gotags: json:"prefix"
   *
   * @generated from field: string prefix = 3;
   */
  prefix: string;

  /**
   * @gotags: json:"store_id"
   *
   * @generated from field: string store_id = 4 [json_name = "store_id"];
   */
  storeId: string;

  /**
   * @gotags: json:"user_id"
   *
   * @generated from field: string user_id = 5 [json_name = "user_id"];
   */
  userId: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetInfiniMemoryScopeData.
 * Use `create(GetInfiniMemoryScopeDataSchema)` to create a new message.
 */
export const GetInfiniMemoryScopeDataSchema: GenMessage<GetInfiniMemoryScopeData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 42);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListInfiniMemoryStoresRequest
 */
export type ListInfiniMemoryStoresRequest = Message<"infinigence.infini.agentplatform.httpv2.ListInfiniMemoryStoresRequest"> & {
  /**
   * @gotags: json:"prefix"
   *
   * @generated from field: string prefix = 1;
   */
  prefix: string;

  /**
   * @gotags: json:"query,omitempty"
   *
   * @generated from field: string query = 2;
   */
  query: string;

  /**
   * @gotags: json:"limit,omitempty"
   *
   * @generated from field: int32 limit = 3;
   */
  limit: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListInfiniMemoryStoresRequest.
 * Use `create(ListInfiniMemoryStoresRequestSchema)` to create a new message.
 */
export const ListInfiniMemoryStoresRequestSchema: GenMessage<ListInfiniMemoryStoresRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 43);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListInfiniMemoryStoresResponse
 */
export type ListInfiniMemoryStoresResponse = Message<"infinigence.infini.agentplatform.httpv2.ListInfiniMemoryStoresResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.ListInfiniMemoryStoresData data = 4;
   */
  data?: ListInfiniMemoryStoresData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListInfiniMemoryStoresResponse.
 * Use `create(ListInfiniMemoryStoresResponseSchema)` to create a new message.
 */
export const ListInfiniMemoryStoresResponseSchema: GenMessage<ListInfiniMemoryStoresResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 44);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListInfiniMemoryStoresData
 */
export type ListInfiniMemoryStoresData = Message<"infinigence.infini.agentplatform.httpv2.ListInfiniMemoryStoresData"> & {
  /**
   * @gotags: json:"stores"
   *
   * @generated from field: repeated string stores = 1;
   */
  stores: string[];
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListInfiniMemoryStoresData.
 * Use `create(ListInfiniMemoryStoresDataSchema)` to create a new message.
 */
export const ListInfiniMemoryStoresDataSchema: GenMessage<ListInfiniMemoryStoresData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 45);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListInfiniMemoryUsersRequest
 */
export type ListInfiniMemoryUsersRequest = Message<"infinigence.infini.agentplatform.httpv2.ListInfiniMemoryUsersRequest"> & {
  /**
   * @gotags: json:"prefix"
   *
   * @generated from field: string prefix = 1;
   */
  prefix: string;

  /**
   * @gotags: json:"store_id"
   *
   * @generated from field: string store_id = 2 [json_name = "store_id"];
   */
  storeId: string;

  /**
   * @gotags: json:"query,omitempty"
   *
   * @generated from field: string query = 3;
   */
  query: string;

  /**
   * @gotags: json:"limit,omitempty"
   *
   * @generated from field: int32 limit = 4;
   */
  limit: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListInfiniMemoryUsersRequest.
 * Use `create(ListInfiniMemoryUsersRequestSchema)` to create a new message.
 */
export const ListInfiniMemoryUsersRequestSchema: GenMessage<ListInfiniMemoryUsersRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 46);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListInfiniMemoryUsersResponse
 */
export type ListInfiniMemoryUsersResponse = Message<"infinigence.infini.agentplatform.httpv2.ListInfiniMemoryUsersResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.ListInfiniMemoryUsersData data = 4;
   */
  data?: ListInfiniMemoryUsersData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListInfiniMemoryUsersResponse.
 * Use `create(ListInfiniMemoryUsersResponseSchema)` to create a new message.
 */
export const ListInfiniMemoryUsersResponseSchema: GenMessage<ListInfiniMemoryUsersResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 47);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListInfiniMemoryUsersData
 */
export type ListInfiniMemoryUsersData = Message<"infinigence.infini.agentplatform.httpv2.ListInfiniMemoryUsersData"> & {
  /**
   * @gotags: json:"users"
   *
   * @generated from field: repeated string users = 1;
   */
  users: string[];
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListInfiniMemoryUsersData.
 * Use `create(ListInfiniMemoryUsersDataSchema)` to create a new message.
 */
export const ListInfiniMemoryUsersDataSchema: GenMessage<ListInfiniMemoryUsersData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 48);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListInfiniMemoriesRequest
 */
export type ListInfiniMemoriesRequest = Message<"infinigence.infini.agentplatform.httpv2.ListInfiniMemoriesRequest"> & {
  /**
   * @gotags: json:"prefix"
   *
   * @generated from field: string prefix = 1;
   */
  prefix: string;

  /**
   * @gotags: json:"store_id"
   *
   * @generated from field: string store_id = 2 [json_name = "store_id"];
   */
  storeId: string;

  /**
   * @gotags: json:"user_id"
   *
   * @generated from field: string user_id = 3 [json_name = "user_id"];
   */
  userId: string;

  /**
   * @gotags: json:"query,omitempty"
   *
   * @generated from field: string query = 4;
   */
  query: string;

  /**
   * all/current/memory.
   * @gotags: json:"kind"
   *
   * @generated from field: string kind = 5;
   */
  kind: string;

  /**
   * @gotags: json:"offset"
   *
   * @generated from field: int32 offset = 6;
   */
  offset: number;

  /**
   * @gotags: json:"limit"
   *
   * @generated from field: int32 limit = 7;
   */
  limit: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListInfiniMemoriesRequest.
 * Use `create(ListInfiniMemoriesRequestSchema)` to create a new message.
 */
export const ListInfiniMemoriesRequestSchema: GenMessage<ListInfiniMemoriesRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 49);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListInfiniMemoriesResponse
 */
export type ListInfiniMemoriesResponse = Message<"infinigence.infini.agentplatform.httpv2.ListInfiniMemoriesResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.ListInfiniMemoriesData data = 4;
   */
  data?: ListInfiniMemoriesData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListInfiniMemoriesResponse.
 * Use `create(ListInfiniMemoriesResponseSchema)` to create a new message.
 */
export const ListInfiniMemoriesResponseSchema: GenMessage<ListInfiniMemoriesResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 50);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListInfiniMemoriesData
 */
export type ListInfiniMemoriesData = Message<"infinigence.infini.agentplatform.httpv2.ListInfiniMemoriesData"> & {
  /**
   * @gotags: json:"items"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.httpv2.InfiniMemoryItem items = 1;
   */
  items: InfiniMemoryItem[];

  /**
   * @gotags: json:"total"
   *
   * @generated from field: int32 total = 2;
   */
  total: number;

  /**
   * @gotags: json:"offset"
   *
   * @generated from field: int32 offset = 3;
   */
  offset: number;

  /**
   * @gotags: json:"limit"
   *
   * @generated from field: int32 limit = 4;
   */
  limit: number;

  /**
   * @gotags: json:"stats"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.InfiniMemoryStats stats = 5;
   */
  stats?: InfiniMemoryStats | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListInfiniMemoriesData.
 * Use `create(ListInfiniMemoriesDataSchema)` to create a new message.
 */
export const ListInfiniMemoriesDataSchema: GenMessage<ListInfiniMemoriesData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 51);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetInfiniMemoryRequest
 */
export type GetInfiniMemoryRequest = Message<"infinigence.infini.agentplatform.httpv2.GetInfiniMemoryRequest"> & {
  /**
   * @gotags: json:"document_id"
   *
   * @generated from field: string document_id = 1 [json_name = "document_id"];
   */
  documentId: string;

  /**
   * @gotags: json:"prefix"
   *
   * @generated from field: string prefix = 2;
   */
  prefix: string;

  /**
   * @gotags: json:"store_id"
   *
   * @generated from field: string store_id = 3 [json_name = "store_id"];
   */
  storeId: string;

  /**
   * @gotags: json:"user_id"
   *
   * @generated from field: string user_id = 4 [json_name = "user_id"];
   */
  userId: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetInfiniMemoryRequest.
 * Use `create(GetInfiniMemoryRequestSchema)` to create a new message.
 */
export const GetInfiniMemoryRequestSchema: GenMessage<GetInfiniMemoryRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 52);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetInfiniMemoryResponse
 */
export type GetInfiniMemoryResponse = Message<"infinigence.infini.agentplatform.httpv2.GetInfiniMemoryResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.GetInfiniMemoryData data = 4;
   */
  data?: GetInfiniMemoryData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetInfiniMemoryResponse.
 * Use `create(GetInfiniMemoryResponseSchema)` to create a new message.
 */
export const GetInfiniMemoryResponseSchema: GenMessage<GetInfiniMemoryResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 53);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetInfiniMemoryData
 */
export type GetInfiniMemoryData = Message<"infinigence.infini.agentplatform.httpv2.GetInfiniMemoryData"> & {
  /**
   * @gotags: json:"document"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.InfiniMemoryDetail document = 1;
   */
  document?: InfiniMemoryDetail | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetInfiniMemoryData.
 * Use `create(GetInfiniMemoryDataSchema)` to create a new message.
 */
export const GetInfiniMemoryDataSchema: GenMessage<GetInfiniMemoryData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 54);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CreateInfiniMemoryRequest
 */
export type CreateInfiniMemoryRequest = Message<"infinigence.infini.agentplatform.httpv2.CreateInfiniMemoryRequest"> & {
  /**
   * @gotags: json:"prefix"
   *
   * @generated from field: string prefix = 1;
   */
  prefix: string;

  /**
   * @gotags: json:"store_id"
   *
   * @generated from field: string store_id = 2 [json_name = "store_id"];
   */
  storeId: string;

  /**
   * @gotags: json:"user_id"
   *
   * @generated from field: string user_id = 3 [json_name = "user_id"];
   */
  userId: string;

  /**
   * @gotags: json:"content"
   *
   * @generated from field: string content = 4;
   */
  content: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CreateInfiniMemoryRequest.
 * Use `create(CreateInfiniMemoryRequestSchema)` to create a new message.
 */
export const CreateInfiniMemoryRequestSchema: GenMessage<CreateInfiniMemoryRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 55);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CreateInfiniMemoryResponse
 */
export type CreateInfiniMemoryResponse = Message<"infinigence.infini.agentplatform.httpv2.CreateInfiniMemoryResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.CreateInfiniMemoryData data = 4;
   */
  data?: CreateInfiniMemoryData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CreateInfiniMemoryResponse.
 * Use `create(CreateInfiniMemoryResponseSchema)` to create a new message.
 */
export const CreateInfiniMemoryResponseSchema: GenMessage<CreateInfiniMemoryResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 56);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CreateInfiniMemoryData
 */
export type CreateInfiniMemoryData = Message<"infinigence.infini.agentplatform.httpv2.CreateInfiniMemoryData"> & {
  /**
   * @gotags: json:"status"
   *
   * @generated from field: string status = 1;
   */
  status: string;

  /**
   * @gotags: json:"document_id"
   *
   * @generated from field: string document_id = 2 [json_name = "document_id"];
   */
  documentId: string;

  /**
   * @gotags: json:"rotated"
   *
   * @generated from field: bool rotated = 3;
   */
  rotated: boolean;

  /**
   * Optional when the working memory rotates.
   * @gotags: json:"document,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.InfiniMemoryDetail document = 4;
   */
  document?: InfiniMemoryDetail | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CreateInfiniMemoryData.
 * Use `create(CreateInfiniMemoryDataSchema)` to create a new message.
 */
export const CreateInfiniMemoryDataSchema: GenMessage<CreateInfiniMemoryData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 57);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UpdateInfiniMemoryRequest
 */
export type UpdateInfiniMemoryRequest = Message<"infinigence.infini.agentplatform.httpv2.UpdateInfiniMemoryRequest"> & {
  /**
   * @gotags: json:"document_id"
   *
   * @generated from field: string document_id = 1 [json_name = "document_id"];
   */
  documentId: string;

  /**
   * @gotags: json:"prefix"
   *
   * @generated from field: string prefix = 2;
   */
  prefix: string;

  /**
   * @gotags: json:"store_id"
   *
   * @generated from field: string store_id = 3 [json_name = "store_id"];
   */
  storeId: string;

  /**
   * @gotags: json:"user_id"
   *
   * @generated from field: string user_id = 4 [json_name = "user_id"];
   */
  userId: string;

  /**
   * @gotags: json:"content"
   *
   * @generated from field: string content = 5;
   */
  content: string;

  /**
   * @gotags: json:"revision"
   *
   * @generated from field: string revision = 6;
   */
  revision: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UpdateInfiniMemoryRequest.
 * Use `create(UpdateInfiniMemoryRequestSchema)` to create a new message.
 */
export const UpdateInfiniMemoryRequestSchema: GenMessage<UpdateInfiniMemoryRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 58);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UpdateInfiniMemoryResponse
 */
export type UpdateInfiniMemoryResponse = Message<"infinigence.infini.agentplatform.httpv2.UpdateInfiniMemoryResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.UpdateInfiniMemoryData data = 4;
   */
  data?: UpdateInfiniMemoryData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UpdateInfiniMemoryResponse.
 * Use `create(UpdateInfiniMemoryResponseSchema)` to create a new message.
 */
export const UpdateInfiniMemoryResponseSchema: GenMessage<UpdateInfiniMemoryResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 59);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UpdateInfiniMemoryData
 */
export type UpdateInfiniMemoryData = Message<"infinigence.infini.agentplatform.httpv2.UpdateInfiniMemoryData"> & {
  /**
   * @gotags: json:"changed"
   *
   * @generated from field: bool changed = 1;
   */
  changed: boolean;

  /**
   * @gotags: json:"rotated"
   *
   * @generated from field: bool rotated = 2;
   */
  rotated: boolean;

  /**
   * Optional when the working memory rotates.
   * @gotags: json:"document,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.InfiniMemoryDetail document = 3;
   */
  document?: InfiniMemoryDetail | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UpdateInfiniMemoryData.
 * Use `create(UpdateInfiniMemoryDataSchema)` to create a new message.
 */
export const UpdateInfiniMemoryDataSchema: GenMessage<UpdateInfiniMemoryData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 60);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteInfiniMemoryRequest
 */
export type DeleteInfiniMemoryRequest = Message<"infinigence.infini.agentplatform.httpv2.DeleteInfiniMemoryRequest"> & {
  /**
   * @gotags: json:"document_id"
   *
   * @generated from field: string document_id = 1 [json_name = "document_id"];
   */
  documentId: string;

  /**
   * @gotags: json:"prefix"
   *
   * @generated from field: string prefix = 2;
   */
  prefix: string;

  /**
   * @gotags: json:"store_id"
   *
   * @generated from field: string store_id = 3 [json_name = "store_id"];
   */
  storeId: string;

  /**
   * @gotags: json:"user_id"
   *
   * @generated from field: string user_id = 4 [json_name = "user_id"];
   */
  userId: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteInfiniMemoryRequest.
 * Use `create(DeleteInfiniMemoryRequestSchema)` to create a new message.
 */
export const DeleteInfiniMemoryRequestSchema: GenMessage<DeleteInfiniMemoryRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 61);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteInfiniMemoryResponse
 */
export type DeleteInfiniMemoryResponse = Message<"infinigence.infini.agentplatform.httpv2.DeleteInfiniMemoryResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.DeleteInfiniMemoryData data = 4;
   */
  data?: DeleteInfiniMemoryData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteInfiniMemoryResponse.
 * Use `create(DeleteInfiniMemoryResponseSchema)` to create a new message.
 */
export const DeleteInfiniMemoryResponseSchema: GenMessage<DeleteInfiniMemoryResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 62);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteInfiniMemoryData
 */
export type DeleteInfiniMemoryData = Message<"infinigence.infini.agentplatform.httpv2.DeleteInfiniMemoryData"> & {
  /**
   * @gotags: json:"status"
   *
   * @generated from field: string status = 1;
   */
  status: string;

  /**
   * @gotags: json:"document_id"
   *
   * @generated from field: string document_id = 2 [json_name = "document_id"];
   */
  documentId: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteInfiniMemoryData.
 * Use `create(DeleteInfiniMemoryDataSchema)` to create a new message.
 */
export const DeleteInfiniMemoryDataSchema: GenMessage<DeleteInfiniMemoryData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_memory, 63);

/**
 * MemoryHTTPV2Service
 * 记忆实例 / 记忆类 的 CRUD，以及底层 Cortex 记忆条目（item）代理操作。
 *
 * @generated from service infinigence.infini.agentplatform.httpv2.MemoryHTTPV2Service
 */
export const MemoryHTTPV2Service: GenService<{
  /**
   * ---- Memory Class ----
   * 列出记忆类（分页 / 过滤）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.MemoryHTTPV2Service.ListMemoryClasses
   */
  listMemoryClasses: {
    methodKind: "unary";
    input: typeof ListRequestSchema;
    output: typeof ListMemoryClassesResponseSchema;
  },
  /**
   * 创建记忆类
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.MemoryHTTPV2Service.CreateMemoryClass
   */
  createMemoryClass: {
    methodKind: "unary";
    input: typeof CreateMemoryClassRequestSchema;
    output: typeof CreateMemoryClassResponseSchema;
  },
  /**
   * 获取单个记忆类
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.MemoryHTTPV2Service.GetMemoryClass
   */
  getMemoryClass: {
    methodKind: "unary";
    input: typeof GetMemoryClassRequestSchema;
    output: typeof GetMemoryClassResponseSchema;
  },
  /**
   * 更新记忆类
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.MemoryHTTPV2Service.UpdateMemoryClass
   */
  updateMemoryClass: {
    methodKind: "unary";
    input: typeof UpdateMemoryClassRequestSchema;
    output: typeof UpdateMemoryClassResponseSchema;
  },
  /**
   * 删除记忆类（幂等：已删除返回 200）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.MemoryHTTPV2Service.DeleteMemoryClass
   */
  deleteMemoryClass: {
    methodKind: "unary";
    input: typeof DeleteMemoryClassRequestSchema;
    output: typeof DeleteMemoryClassResponseSchema;
  },
  /**
   * ---- Memory Instance ----
   * 列出记忆实例（分页 / 过滤）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.MemoryHTTPV2Service.ListMemories
   */
  listMemories: {
    methodKind: "unary";
    input: typeof ListRequestSchema;
    output: typeof ListMemoriesResponseSchema;
  },
  /**
   * 创建记忆实例
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.MemoryHTTPV2Service.CreateMemory
   */
  createMemory: {
    methodKind: "unary";
    input: typeof CreateMemoryRequestSchema;
    output: typeof CreateMemoryResponseSchema;
  },
  /**
   * 获取单个记忆实例
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.MemoryHTTPV2Service.GetMemory
   */
  getMemory: {
    methodKind: "unary";
    input: typeof GetMemoryRequestSchema;
    output: typeof GetMemoryResponseSchema;
  },
  /**
   * 更新记忆实例
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.MemoryHTTPV2Service.UpdateMemory
   */
  updateMemory: {
    methodKind: "unary";
    input: typeof UpdateMemoryRequestSchema;
    output: typeof UpdateMemoryResponseSchema;
  },
  /**
   * 删除记忆实例（幂等：已删除返回 200）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.MemoryHTTPV2Service.DeleteMemory
   */
  deleteMemory: {
    methodKind: "unary";
    input: typeof DeleteMemoryRequestSchema;
    output: typeof DeleteMemoryResponseSchema;
  },
  /**
   * ---- Cortex Memory Item（代理到 cortex 服务） ----
   * 列出底层 cortex 记忆条目
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.MemoryHTTPV2Service.ListCortexItems
   */
  listCortexItems: {
    methodKind: "unary";
    input: typeof ListCortexItemsRequestSchema;
    output: typeof ListCortexItemsResponseSchema;
  },
  /**
   * 获取单个 cortex 记忆条目
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.MemoryHTTPV2Service.GetCortexItem
   */
  getCortexItem: {
    methodKind: "unary";
    input: typeof GetCortexItemRequestSchema;
    output: typeof GetCortexItemResponseSchema;
  },
  /**
   * 创建 cortex 记忆条目
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.MemoryHTTPV2Service.CreateCortexItem
   */
  createCortexItem: {
    methodKind: "unary";
    input: typeof CreateCortexItemRequestSchema;
    output: typeof CreateCortexItemResponseSchema;
  },
  /**
   * 更新 cortex 记忆条目
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.MemoryHTTPV2Service.UpdateCortexItem
   */
  updateCortexItem: {
    methodKind: "unary";
    input: typeof UpdateCortexItemRequestSchema;
    output: typeof UpdateCortexItemResponseSchema;
  },
  /**
   * 删除单个 cortex 记忆条目
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.MemoryHTTPV2Service.DeleteCortexItem
   */
  deleteCortexItem: {
    methodKind: "unary";
    input: typeof DeleteCortexItemRequestSchema;
    output: typeof DeleteCortexItemResponseSchema;
  },
  /**
   * 删除某 store 下某 user 的全部 cortex 记忆条目
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.MemoryHTTPV2Service.DeleteAllCortexItems
   */
  deleteAllCortexItems: {
    methodKind: "unary";
    input: typeof DeleteAllCortexItemsRequestSchema;
    output: typeof DeleteAllCortexItemsResponseSchema;
  },
  /**
   * 语义检索 cortex 记忆条目
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.MemoryHTTPV2Service.SearchCortexItems
   */
  searchCortexItems: {
    methodKind: "unary";
    input: typeof SearchCortexItemsRequestSchema;
    output: typeof SearchCortexItemsResponseSchema;
  },
  /**
   * ---- infini-memory（代理到 Cortex 管理接口） ----
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.MemoryHTTPV2Service.GetInfiniMemoryScope
   */
  getInfiniMemoryScope: {
    methodKind: "unary";
    input: typeof GetInfiniMemoryScopeRequestSchema;
    output: typeof GetInfiniMemoryScopeResponseSchema;
  },
  /**
   * @generated from rpc infinigence.infini.agentplatform.httpv2.MemoryHTTPV2Service.ListInfiniMemoryStores
   */
  listInfiniMemoryStores: {
    methodKind: "unary";
    input: typeof ListInfiniMemoryStoresRequestSchema;
    output: typeof ListInfiniMemoryStoresResponseSchema;
  },
  /**
   * @generated from rpc infinigence.infini.agentplatform.httpv2.MemoryHTTPV2Service.ListInfiniMemoryUsers
   */
  listInfiniMemoryUsers: {
    methodKind: "unary";
    input: typeof ListInfiniMemoryUsersRequestSchema;
    output: typeof ListInfiniMemoryUsersResponseSchema;
  },
  /**
   * @generated from rpc infinigence.infini.agentplatform.httpv2.MemoryHTTPV2Service.ListInfiniMemories
   */
  listInfiniMemories: {
    methodKind: "unary";
    input: typeof ListInfiniMemoriesRequestSchema;
    output: typeof ListInfiniMemoriesResponseSchema;
  },
  /**
   * @generated from rpc infinigence.infini.agentplatform.httpv2.MemoryHTTPV2Service.GetInfiniMemory
   */
  getInfiniMemory: {
    methodKind: "unary";
    input: typeof GetInfiniMemoryRequestSchema;
    output: typeof GetInfiniMemoryResponseSchema;
  },
  /**
   * @generated from rpc infinigence.infini.agentplatform.httpv2.MemoryHTTPV2Service.CreateInfiniMemory
   */
  createInfiniMemory: {
    methodKind: "unary";
    input: typeof CreateInfiniMemoryRequestSchema;
    output: typeof CreateInfiniMemoryResponseSchema;
  },
  /**
   * @generated from rpc infinigence.infini.agentplatform.httpv2.MemoryHTTPV2Service.UpdateInfiniMemory
   */
  updateInfiniMemory: {
    methodKind: "unary";
    input: typeof UpdateInfiniMemoryRequestSchema;
    output: typeof UpdateInfiniMemoryResponseSchema;
  },
  /**
   * @generated from rpc infinigence.infini.agentplatform.httpv2.MemoryHTTPV2Service.DeleteInfiniMemory
   */
  deleteInfiniMemory: {
    methodKind: "unary";
    input: typeof DeleteInfiniMemoryRequestSchema;
    output: typeof DeleteInfiniMemoryResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_agentplatform_httpv2_memory, 0);

